import React from 'react';
import {
	BrowserRouter , Routes, Route,
} from "react-router-dom";

import Home from './component/home';
import Meeting from './component/meeting';

function App() {
	return (
		<BrowserRouter>
			<Routes>
				<Route exact path="/" element={<Home/>} />
				<Route path="/:id" element={<Meeting/>} />
			</Routes>
		</BrowserRouter>
	);
}
export default App;
